import { FC } from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartData,
  CoreChartOptions,
  ElementChartOptions,
  PluginChartOptions,
  DatasetChartOptions,
  ScaleChartOptions,
  DoughnutControllerChartOptions,
  Plugin,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { _DeepPartialObject } from "chart.js/dist/types/utils";
import { AnyObject } from "chart.js/dist/types/basic";
import {
  ChartTextWrapper,
  ChartWrapper,
  InfoWrapper,
  StyledChart,
  StyledText,
} from "./styled";
import { Typography } from "antd";
import { ArrowLeft } from "../icons/ArrowLeft";

ChartJS.register(ArcElement, Tooltip, Legend);

interface IProps {
  data: ChartData<"doughnut", number[], unknown>;
  options?:
    | _DeepPartialObject<
        CoreChartOptions<"doughnut"> &
          ElementChartOptions<"doughnut"> &
          PluginChartOptions<"doughnut"> &
          DatasetChartOptions<"doughnut"> &
          ScaleChartOptions &
          DoughnutControllerChartOptions
      >
    | undefined;
  plugins?: Plugin<"doughnut", AnyObject>[] | undefined;
  percent: string;
  title?: string;
  value: string;
  color: string;
  transform: string;
}

export const DonutChart: FC<IProps> = ({
  data,
  options,
  plugins,
  percent,
  title,
  value,
  color,
  transform,
}) => {
  return (
    <StyledChart>
      <Typography.Title style={{ margin: 0 }} level={5}>
        {title}
      </Typography.Title>

      <InfoWrapper>
        <ChartWrapper>
          <ChartTextWrapper>
            <span style={{ fontSize: "40px", height: "min-content" }}>
              {value}
            </span>
            <p
              style={{
                fontSize: "16px",
                height: "min-content",
                marginTop: "6px",
              }}
            >
              %
            </p>
          </ChartTextWrapper>
          <Doughnut data={data} options={options} plugins={plugins} />
        </ChartWrapper>

        <div style={{ display: "flex" }}>
          <div style={{ marginTop: "5px" }}>
            <ArrowLeft style={{ stroke: color, transform: transform}} className="arrow" />
          </div>

          <StyledText style={{ color: color }}>{percent}%</StyledText>
        </div>
      </InfoWrapper>
    </StyledChart>
  );
};
